/* eslint-disable @typescript-eslint/no-unused-vars-experimental */
import * as React from 'react';
import styled from 'styled-components';
import { PowerProgressBar } from '../PowerProgressBar';
import { SvgProps } from '../Svg/Svg.types';
import { Text } from '../Text';

const DevicePowerConsumptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 84px;
  min-width: 264px;
  padding: 12px 17px 17px 12px;
  background: transparent;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background: ${({ theme }) =>
      theme.isDark ? 'rgba(147, 255, 200, 0.05)' : 'rgba(147, 255, 200, 0.15)'};
  }
`;

const StyledDescriptionRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledPowerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const StyledDeviceName = styled(Text)`
  font-weight: 500;
  font-size: 16px;
  line-height: 32px;
  letter-spacing: 0.18px;
  color: ${({ theme }) => theme.colors.font1};
  margin-left: 12px;
`;

const StyledDeviceConsumption = styled(Text)`
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0.18px;
  color: ${({ theme }) => theme.colors.font1};
`;

export interface IDevicePowerConsumptionProps {
  deviceName: string;
  deviceNumber: number;
  deviceIcon: React.ReactElement;
  currentConsumption: number;
  maxConsumption: number;
  onHover?: (deviceNumber: number) => void;
}

const DevicePowerConsumption: React.FunctionComponent<IDevicePowerConsumptionProps> = props => {
  const {
    deviceName,
    deviceNumber,
    deviceIcon,
    currentConsumption,
    maxConsumption,
    onHover
  } = props;

  return (
    <DevicePowerConsumptionWrapper
      onMouseOver={() => onHover && onHover(deviceNumber)}
    >
      <StyledDescriptionRow>
        {deviceIcon} <StyledDeviceName>{deviceName}</StyledDeviceName>
      </StyledDescriptionRow>
      <StyledPowerRow>
        <StyledDeviceConsumption>
          {currentConsumption} W
        </StyledDeviceConsumption>
        <PowerProgressBar
          currentValue={currentConsumption}
          maxValue={maxConsumption}
          customWidth="157px"
        />
      </StyledPowerRow>
    </DevicePowerConsumptionWrapper>
  );
};

export default DevicePowerConsumption;
